import {IHomeworkReportTotalSummary} from '../../constants'

export function reportMetrics(summary?: Partial<IHomeworkReportTotalSummary>) {
  const total = Math.max(0, Number(summary?.totalHomeworkCount) || 0)
  const completed = Math.min(total, Math.max(0, Number(summary?.completedHomework) || 0))
  const remaining = total - completed
  return {total, completed, remaining, percent: total ? Math.round(completed / total * 100) : 0,
    duration: Math.max(0, Number(summary?.sessionDuration) || 0)}
}

export function readingTime(milliseconds: number) {
  const seconds = Math.floor(Math.max(0, milliseconds || 0) / 1000)
  if (seconds < 60) return `${seconds} sn`
  const minutes = Math.floor(seconds / 60)
  return minutes < 60 ? `${minutes} dk` : `${Math.floor(minutes / 60)} sa ${minutes % 60} dk`
}
